import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-posm-customer-add',
  templateUrl: './posm-customer-add.page.html',
  styleUrls: ['./posm-customer-add.page.scss'],
})
export class PosmCustomerAddPage implements OnInit {

  data = new Data();
  myId: any;
  ipAddress: any;

  pre_user_firstname: any;
  pre_user_lastname: any;
  pre_user_ic: any;
  pre_user_address1: any;
  pre_user_address2: any;
  pre_user_email: any;
  pre_user_postcode: any;
  pre_user_city: any;
  pre_user_state: any;
  pre_user_phone: any;

  constructor(private apiService: ApiService, private http: HttpClient, private router: Router, private activatedRoute: ActivatedRoute, public dialog: MatDialog, private spinner: NgxSpinnerService) {


  }

  ngOnInit() {
    this.getIPAddress();
  }

  

  submit() {
    this.spinner.show();

    if (this.pre_user_lastname === undefined) this.pre_user_lastname = '';
    if (this.pre_user_address2 === undefined) this.pre_user_address2 = '';
    if (this.pre_user_email === undefined) this.pre_user_email = '';

    const dt3 = {
      userFname: this.pre_user_firstname,
      userLname: this.pre_user_lastname,
      userIc: this.pre_user_ic,
      userAddress: this.pre_user_address1,
      userAddress2: this.pre_user_address2,
      userProvince: this.pre_user_state,
      userCity: this.pre_user_city,
      userPostCode: this.pre_user_postcode,
      userEmail: this.pre_user_email,
      userPhone: this.pre_user_phone,
      ipAddress: this.ipAddress,
      status: 1
    };
    
      this.data.id = 1;
      this.data.name = 'posUserRegister';
      this.data.content = dt3;

      console.log(this.data);

      this.apiService.postData(this.data).subscribe((response) => {
        this.spinner.hide();
        this.openDialog();
        this.router.navigate(['/members/posm-customer']);
        console.log(response);
    });
  }

  proceed() {
    this.spinner.show();

    if (this.pre_user_lastname === undefined) this.pre_user_lastname = '';
    if (this.pre_user_address2 === undefined) this.pre_user_address2 = '';
    if (this.pre_user_email === undefined) this.pre_user_email = '';

    const dt3 = {
      userFname: this.pre_user_firstname,
      userLname: this.pre_user_lastname,
      userIc: this.pre_user_ic,
      userAddress: this.pre_user_address1,
      userAddress2: this.pre_user_address2,
      userProvince: this.pre_user_state,
      userCity: this.pre_user_city,
      userPostCode: this.pre_user_postcode,
      userEmail: this.pre_user_email,
      userPhone: this.pre_user_phone,
      ipAddress: this.ipAddress,
      status: 1
    };
    
      this.data.id = 1;
      this.data.name = 'posUserRegister';
      this.data.content = dt3;

      console.log(this.data);

      this.apiService.postData(this.data).subscribe((response) => {
        this.spinner.hide();
        this.router.navigate(['/members/posm/0/'+ response.data[0].id]);
        console.log(response);
    });
  }

  getIPAddress() {
    this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogTenPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogTenPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
